import { AuditActionName, AuditActorKindName } from "../types";

/**
 * Denetim izi görüntü sözlüğü: işlem / aktör / alan adları ve değer biçimleme.
 * Alan adları C# özellik adıdır (ör. "PaymentTermDays"); burada olmayanlar
 * sondaki "Id" atılıp PascalCase bölünerek okunur hale getirilir.
 */

export const ACTION_LABEL: Record<AuditActionName, string> = {
  Insert: "Ekleme",
  Update: "Değişiklik",
  Delete: "Silme",
  SoftDelete: "Pasife alındı",
  Restore: "Yeniden aktif",
  Event: "Olay",
};

/** Satır rozeti sınıfı (k1…k6) — Cheques'teki ch-kind ile aynı mantık. */
export const ACTION_CLASS: Record<AuditActionName, string> = {
  Insert: "k1",
  Update: "k2",
  Delete: "k3",
  SoftDelete: "k4",
  Restore: "k5",
  Event: "k6",
};

export const ACTOR_KIND_LABEL: Record<AuditActorKindName, string> = {
  User: "Kullanıcı",
  System: "Sistem",
  Anonymous: "Ziyaretçi",
  Device: "Cihaz",
};

export const AREA_LABEL: Record<string, string> = {
  orders: "Sipariş ve Fatura",
  definitions: "Tanımlamalar",
  stock: "Stok",
  purchasing: "Satın Alma",
  shipping: "Sevkiyat",
  finance: "Finans",
  reports: "Maliyet ve Rapor",
  hr: "İnsan Kaynakları",
  appointments: "Randevu",
  security: "Güvenlik ve Yetki",
  system: "Sistem",
  other: "Diğer",
};

export const MASK = "•••";

const FIELD_LABEL: Record<string, string> = {
  Name: "Ad", Code: "Kod", Note: "Not", Notes: "Notlar", Description: "Açıklama", Title: "Başlık",
  Price: "Fiyat", UnitPrice: "Birim fiyat", Amount: "Tutar", Currency: "Para birimi", CurrencyCode: "Para birimi",
  Quantity: "Miktar", Unit: "Birim", Status: "Durum", Priority: "Öncelik", Deadline: "Termin", DueDate: "Vade",
  IssueDate: "Keşide tarihi", Date: "Tarih", OrderDate: "Sipariş tarihi", IsActive: "Aktif", IsDefault: "Varsayılan",
  Email: "E-posta", Phone: "Telefon", Address: "Adres", TaxNumber: "Vergi no", TCKN: "TCKN", TaxOffice: "Vergi dairesi",
  Iban: "IBAN", AccountNo: "Hesap no", FirstName: "Ad", LastName: "Soyad", Role: "Rol", RoleId: "Rol", Balance: "Bakiye",
  VatRate: "KDV oranı", Total: "Toplam", GrandTotal: "Genel toplam", Number: "No", BankName: "Banka", BranchName: "Şube",
  Drawer: "Keşideci", AssignedUserId: "Sorumlu", WorkshopId: "Atölye", FirmId: "Firma", ModelId: "Model",
  SupplierId: "Tedarikçi", StockId: "Stok", OrderId: "Sipariş", EmployeeId: "Personel", FinancialAccountId: "Hesap",
  PasswordHash: "Şifre", NationalId: "TC kimlik no", HealthNotes: "Sağlık notu", HireDate: "İşe giriş", ManagerId: "Yönetici",
  ProfitMargin: "Kar marjı", OverheadCostRate: "Genel gider oranı", PricesIncludeVat: "Fiyatlar KDV dahil",
  DefaultVatRate: "Varsayılan KDV", VatRates: "KDV oranları", FaturasizSeriesCode: "Faturasız seri kodu",
  InvoiceLineSuffix: "Fatura satırı eki", DefaultPaymentTermDays: "Fatura vadesi (gün)",
  NotifyCustomerByEmail: "Müşteriye e-posta", PublicBookingEnabled: "Randevu sayfası yayında",
  AuditRetentionDays: "Denetim izi saklama süresi (gün)", SettingsName: "Ayar adı",
  PaymentTermDays: "Ödeme vadesi (gün)", ContactPerson: "Yetkili kişi", PermissionId: "İzin", UserId: "Kullanıcı",
  DisplayOrder: "Sıra", IsSystem: "Sistem rolü", IsFirstLogin: "İlk giriş", FirmName: "Firma adı", FirmCode: "Firma kodu",
  ModelCode: "Model kodu", ModelName: "Model adı", ProductCode: "Ürün kodu", ProductName: "Ürün adı",
  InvoiceNumber: "Fatura no", DocumentNumber: "Belge no", ErrorMessage: "Hata", ErrorCode: "Hata kodu", Success: "Başarılı",
  MinimumStock: "Asgari stok", CurrentStock: "Mevcut stok", CategoryId: "Kategori", StockCategoryId: "Kategori",
  ShipmentDate: "Sevk tarihi", DeliveredAt: "Teslim zamanı", ReceivedAt: "Teslim alındı", ExpectedDate: "Beklenen tarih",
  Direction: "Yön", Type: "Tür", Kind: "Tür", Source: "Kaynak", Category: "Kategori", ReferenceNo: "Referans no",
  TransactionDate: "İşlem tarihi", IsIn: "Giriş", OpeningBalance: "Açılış bakiyesi", EmployeeNumber: "Sicil no",
  DepartmentId: "Departman", ShiftId: "Vardiya", StartDate: "Başlangıç", EndDate: "Bitiş", Days: "Gün",
  PunchedAt: "Vuruş zamanı", StartsAt: "Başlangıç", EndsAt: "Bitiş", CustomerName: "Müşteri", CustomerEmail: "Müşteri e-posta",
  CustomerPhone: "Müşteri telefon", QrToken: "QR anahtarı", KioskPinHash: "Kiosk PIN", DriverTckn: "Sürücü TCKN",
  DriverName: "Sürücü", Plate: "Plaka", City: "İl", District: "İlçe", CityId: "İl", DistrictId: "İlçe", TaxOfficeId: "Vergi dairesi",
  InvoiceTypeId: "Fatura tipi", OrderStatusId: "Sipariş durumu", OrderUnitId: "Birim", Width: "En", Height: "Boy",
};

/** "PaymentTermDays" → "Payment term days" yerine sözlük; yoksa okunur hale getir. */
export function fieldLabel(name: string): string {
  if (FIELD_LABEL[name]) return FIELD_LABEL[name];
  const base = name.endsWith("Id") && name.length > 2 ? name.slice(0, -2) : name;
  if (FIELD_LABEL[base]) return FIELD_LABEL[base];
  const words = base.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
  return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
}

const ENUM_LABEL: Record<string, string> = {
  Draft: "Taslak", Sent: "Gönderildi", Shipped: "Sevk edildi", Delivered: "Teslim edildi", Cancelled: "İptal",
  InPortfolio: "Portföyde", DepositedToBank: "Bankada", Endorsed: "Ciro edildi", Collected: "Tahsil edildi",
  Bounced: "Karşılıksız", Returned: "İade", In: "Giriş", Out: "Çıkış", Pending: "Bekliyor", Approved: "Onaylandı",
  Rejected: "Reddedildi", Received: "Teslim alındı", PartiallyReceived: "Kısmen teslim", Closed: "Kapandı",
  Issued: "Verilen", Cheque: "Çek", PromissoryNote: "Senet", Cash: "Kasa", Bank: "Banka",
};

/** Olay verisi anahtarları. */
export const DATA_KEY_LABEL: Record<string, string> = {
  reason: "Neden", result: "Sonuç", added: "Eklenen", removed: "Kaldırılan", total: "Toplam", count: "Kayıt",
  rows: "Satır", file: "Dosya", endpoint: "Uç", query: "Süzgeç", report: "Rapor", from: "Başlangıç", to: "Bitiş",
  capped: "Sınıra takıldı", role: "Rol", firstLogin: "İlk giriş", revokedOtherLinks: "İptal edilen diğer bağlantılar",
  required: "Gereken izin", service: "Servis", number: "Belge no", firm: "Firma", currency: "Para birimi",
  generation: "Deneme", simulated: "Simülasyon", errorCode: "Hata kodu", retentionDays: "Saklama (gün)",
  cutoff: "Eşik tarihi", deleted: "Silinen", batches: "Paket", budgetHit: "Süre sınırı doldu", durationMs: "Süre (ms)",
  supplierId: "Tedarikçi", supplier: "Tedarikçi", olderThanDays: "Gün", fields: "Alanlar", updated: "Güncellenen",
  deactivated: "Pasife alınan", ids: "Kimlikler",
};

export const REASON_LABEL: Record<string, string> = {
  "unknown-email": "E-posta kayıtlı değil",
  "wrong-password": "Hatalı şifre",
  "invalid-token": "Geçersiz bağlantı",
  used: "Bağlantı daha önce kullanılmış",
  expired: "Bağlantının süresi dolmuş",
  throttled: "İstek sınırı aşıldı",
  sent: "Bağlantı gönderildi",
};

const ISO_DT = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2}))?)?/;
/** Değerin TAMAMI tarih/saat mi (ör. "2026-10-01-001" gibi tarihle başlayan metin tarih sayılmasın). */
const ISO_DT_FULL = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,7})?)?)?$/;
const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isGuid = (v: unknown): v is string => typeof v === "string" && GUID.test(v);

/** Sunucu tarihleri TR yerel ve ofsetsiz: Date'e çevirmeden, saat kaydırmadan biçimlenir. */
export function fmtLocal(v: string, withSeconds = false): string {
  const m = ISO_DT.exec(v);
  if (!m) return v;
  const [, y, mo, d, h, mi, s] = m;
  if (h === undefined) return `${d}.${mo}.${y}`;
  if (h === "00" && mi === "00" && (!s || s === "00") && !withSeconds) return `${d}.${mo}.${y}`;
  return `${d}.${mo}.${y} ${h}:${mi}${withSeconds && s ? `:${s}` : ""}`;
}

export type ValueKind = "null" | "masked" | "bool" | "number" | "date" | "guid" | "text" | "json";

export function describeValue(v: unknown): { kind: ValueKind; text: string; full?: string } {
  if (v === null || v === undefined || v === "") return { kind: "null", text: "—" };
  if (v === MASK) return { kind: "masked", text: "••••" };
  if (typeof v === "boolean") return { kind: "bool", text: v ? "Evet" : "Hayır" };
  if (typeof v === "number") return { kind: "number", text: v.toLocaleString("tr-TR", { maximumFractionDigits: 4 }) };
  if (typeof v === "string") {
    if (v.includes("••••") && v.length <= 16) return { kind: "masked", text: v };
    if (GUID.test(v)) return { kind: "guid", text: v.slice(0, 8), full: v };
    if (ISO_DT_FULL.test(v)) return { kind: "date", text: fmtLocal(v) };
    if (ENUM_LABEL[v]) return { kind: "text", text: ENUM_LABEL[v], full: v };
    return { kind: "text", text: v };
  }
  try { return { kind: "json", text: JSON.stringify(v) }; } catch { return { kind: "text", text: String(v) }; }
}

/** "3 dk önce", "dün 09:15", "12 Eyl" — TR yerel ofsetsiz zamandan. */
export function relTime(v: string, now = new Date()): string {
  const m = ISO_DT.exec(v);
  if (!m) return "";
  const [, y, mo, d, h = "00", mi = "00", s = "00"] = m;
  const t = new Date(+y, +mo - 1, +d, +h, +mi, +s);
  const diff = (now.getTime() - t.getTime()) / 1000;
  if (diff < 60) return "az önce";
  if (diff < 3600) return `${Math.floor(diff / 60)} dk önce`;
  const sameDay = t.toDateString() === now.toDateString();
  if (sameDay) return `${Math.floor(diff / 3600)} sa önce`;
  const yest = new Date(now); yest.setDate(now.getDate() - 1);
  if (t.toDateString() === yest.toDateString()) return `dün ${h}:${mi}`;
  return t.toLocaleDateString("tr-TR", { day: "numeric", month: "short", year: t.getFullYear() === now.getFullYear() ? undefined : "numeric" });
}

/** E-posta / ad → iki harf; renk tonu addan türer (ch-mark gibi). */
export function initials(text: string): string {
  const base = (text || "?").split("@")[0].replace(/[._-]+/g, " ").trim();
  const parts = base.split(/\s+/).filter(Boolean);
  const a = parts[0]?.[0] || "?";
  const b = parts.length > 1 ? parts[parts.length - 1][0] : parts[0]?.[1] || "";
  return (a + b).toLocaleUpperCase("tr-TR");
}

export function hueOf(text: string): number {
  let h = 0;
  for (let i = 0; i < text.length; i++) h = (h * 31 + text.charCodeAt(i)) % 360;
  return h;
}
